import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { getLocality } from "../../../api/fiasAPI";
import { LIMIT, QUERY } from "../../../constants/fiasAPI";
import { AsynchronousProps } from "../../../types/common";
import { FiasSearchParams, ItemData } from "../../../types/api/fiasAPI";

interface Props extends AsynchronousProps {
    label: string;
    getParam?: keyof ItemData["data"];
    from_bound?: {
        value: string;
    };
    to_bound?: {
        value: string;
    };
    locations?: Array<Record<string, string>>;

    searchParams?: FiasSearchParams;
    parentsVisible?: boolean;
}

const Asynchronous: React.FC<Props> = ({
    onChange,
    getParam,
    from_bound,
    to_bound,
    locations,
    label,
    value,
    field,
    error,
    searchParams,
    parentsVisible,
    callbackResult,
    disabled,
}) => {
    const [options, setOptions] = useState<Array<ItemData>>();
    const [select, setSelect] = useState<ItemData>();
    const [query, setQuery] = useState("");
    const [load, setLoad] = useState(false);
    const fetchData = () => {
        setLoad(true);
        getLocality(
            query,
            from_bound,
            to_bound,
            locations,
            result => {
                setOptions(result.suggestions);
                setLoad(false);
            },
            () => {
                setLoad(false);
            },
            // {
            //     [QUERY]: query,
            //     [LIMIT]: 10,
            //     ...searchParams,
            // },
        );
    };

    useEffect(() => {
        fetchData();
    }, [query]);
    useEffect(() => {
        setQuery(value);
    }, []);

    return (
        <Autocomplete
            value={select}
            // @ts-expect-error fix later
            onChange={(_event, newValue: ItemData) => {
                setSelect(newValue);
                callbackResult && callbackResult(newValue);
                onChange(newValue);
            }}
            inputValue={query ?? ""}
            onInputChange={(_event, newInputValue) => {
                setQuery(newInputValue);
            }}
            noOptionsText={"Нет совпадений"}
            getOptionLabel={option =>
                getParam
                    ? getParam === "house" // @ts-expect-error fix later
                        ? `${option?.data?.house_type ?? ""} ${option?.data?.house ?? ""} ${
                              // @ts-expect-error fix later
                              option?.data?.block_type ?? ""
                          } ${
                              // @ts-expect-error fix later
                              option?.data?.block ?? ""
                          }`
                        : // @ts-expect-error fix later
                          option?.data[getParam]
                    : // @ts-expect-error fix later
                      option?.value ?? option
            }
            options={options || []}
            loading={load}
            freeSolo
            disabled={disabled}
            renderOption={(props, option: ItemData) => {
                return (
                    <li {...props} key={option.value}>
                        <Typography gutterBottom>
                            {getParam
                                ? getParam === "house"
                                    ? `${option?.data?.house_type ?? ""} ${option?.data?.house ?? ""} ${
                                          option?.data?.block_type ?? ""
                                      } ${option?.data?.block ?? ""}`
                                    : (option?.data[getParam] as string)
                                : option.value}
                        </Typography>
                    </li>
                );
            }}
            renderInput={params => (
                <TextField
                    {...params}
                    size={"small"}
                    label={label}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {load ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                    error={!!error}
                    helperText={error?.message}
                />
            )}
        />
    );
};
export default Asynchronous;
